import { doFetchOne } from '@/services/designer_project.service';
import { snakeToCamel } from "@/services/util.service";


export const designerProjectOne = {
    namespaced: true,
    state: {
        one: {},
        inProgress: false
    },
    mutations: {
        setDesingerOne(state, one) {
            state.one = one;
        },
        inProgress(state, yesOrNo) {
            state.inProgress = yesOrNo
        }
    },
    actions: {
        fetchOne: async ({ commit }, id) => {
            commit('inProgress', true);
            try {
                let response = await doFetchOne(id);
                commit('setDesingerOne', snakeToCamel(response));
                commit('inProgress', false);
                return (response);
            }
            catch (err) {
                commit('inProgress', false);
                throw err;
            }
        },
     
    },

}
